import { Layout } from '@/core/layout/layout';
import { type RouteRecordRaw } from 'vue-router';

export default {
    path: '/auth',
    name: 'auth',
    meta: {
        layout: Layout.HeaderOnly,
    },
    component: () => import('../views/Global/AuthView.vue'),
    children: [
        {
            path: 'resetPassword',
            name: 'reset-password',
            component: () => import('@/components/Auth/ResetPassword/ResetPassword.vue'),
        },
        {
            path: 'forgot-password',
            name: 'forgot-password',
            component: () => import('@/components/Auth/ForgotPassword/ForgotPassword.vue'),
        },
        {
            path: 'register',
            name: 'register',
            component: () => import('@/components/Global/Modals/UiModalRegisterNewUsers/UiModalRegisterNewUsers.vue'),
        },
        {
            path: 'invitation',
            name: 'invitation',
            component: () => import('@/components/Auth/UserInvitation/UserInvitation.vue'),
        },
        {
            path: 'logout',
            name: 'logout',
            component: () => import('@/features/auth/pages/LogoutPage.vue'),
        },
        {
            path: ':(.*)',
            redirect: { name: 'login' },
        },
    ],
} as RouteRecordRaw;
